import { useEffect } from "react"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"

import { APP_STATUS, homeScreenMode, updateAppStatus } from "utils/electron"
import { useTranslation } from "providers/i18n"
import { useHome } from "hooks/home/useHome"
import { useHomeMap } from "hooks/home/useHomeMap"

import { FullScreenOverlayLayout } from "layouts/FullScreenOverlayLayout"
import { Head } from "components/Head"
import { NearMeIcon } from "components/icons"
import { formbricksTrack } from "extensions/iconsiam/utils"
import { LeftToRightWrapper } from "components/LeftToRightWrapper"

export const HomePage = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { venues, defaultRoutePath } = useHome()
  const navigate = useNavigate()
  useHomeMap(venues)

  const styleOverrides = theme.components[`HomePage`]?.styleOverrides || {}
  const {
    root,
    actionContainer,
    actionButton,
    contentContainer,
    fullscreenLayout,
    welcomeContainer,
    touchToStartText,
    touchToStartIcon,
    touchTriggerArea,
  } = styleOverrides

  const handleClick = () => {
    if (window.electron) {
      window.electron.sendMessage("setHomeScreenMode", { enable: false })
    }
    formbricksTrack("touch_to_start_kiosk")
    updateAppStatus(APP_STATUS.ACTIVE)
    navigate(defaultRoutePath)
  }

  useEffect(() => {
    homeScreenMode()
  }, [])

  //   useEffect(() => {
  //     if (window.electron) {
  //       window.electron.sendMessage("setHomeScreenMode", { enable: true })
  //     }
  //   }, [])

  return (
    <LeftToRightWrapper>
      <Head title={t("Indoor map")} />
      <Box
        sx={touchTriggerArea}
        className="HomePage-touchTriggerArea"
        onClick={handleClick}
      />
      <Box sx={root} className="home-page">
        <FullScreenOverlayLayout sx={fullscreenLayout}>
          <Box sx={contentContainer} className="contentContainer">
            <Box sx={welcomeContainer}>
              <Box sx={actionContainer}>
                <Button sx={actionButton}>
                  <NearMeIcon sx={touchToStartIcon} />
                  <Typography sx={touchToStartText}>
                    {t("Touch to start")}
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </FullScreenOverlayLayout>
      </Box>
    </LeftToRightWrapper>
  )
}
